/**
 * `crypto.randomUUID` is only defined in a secure context — it is missing when
 * the app is opened over plain HTTP on a LAN address, which is exactly how the
 * QR flow gets tested on a real phone. Fall back rather than throw.
 */
export const generateId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};
